/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  clientAdminProjectData: null ,
  teamsData: null,
  usersData: null,
  city:null,
  gender:null,
  qualification:null,
  Addproject:null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.clientDashboardAction.REQUEST_CLIENTDASHBOARD_DATA:
      return {
        ...state,
    };
    case actions.clientDashboardAction.CLIENTDASHBOARD_DATA_RECEIVED:
          return{
      ...state,
      clientAdminProjectData : action?.data?.projectStatus,
      teamsData: action?.data?.teams,
      usersData: action?.data?.users,
      city: action?.data?.city,
      gender: action?.data?.gender,
      qualification: action?.data?.qualification,
      Addproject:action?.data?.Addproject,

    };

    default:
      return state;
  }
};

export default reducer;
